"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FIELDS_METADATA_SLUG = void 0;
exports.FIELDS_METADATA_SLUG = "fields_metadata";
